export default __webpack_public_path__ + "static/media/up.cee27ed2.svg";